import * as React from 'react';
import {
    ArchetypeSpecificStepRunSummaryPanelProps,
    StepRunSummaryContainer,
    StepRunSummaryDetailItem,
    StepRunSummaryDetailSeparator,
    CIBuildInfoTopBar,
    CIBuildInfoBranchItem,
    CIBuildInfoCommitItem,
    CIBuildInfoMessageItem,
    TagDetailSection,
} from '.';
import { ReleaseStepCIDistributionData } from '@/types';

export const CIDistributionStepRunSummaryPanel: React.FC<ArchetypeSpecificStepRunSummaryPanelProps> = ({
    stepRun,
    shouldDisplayCompactVersion,
}) => {
    const stepData: ReleaseStepCIDistributionData = {
        ...stepRun.data.summaryData,
        ...stepRun.data.complementaryData,
    };

    const ciBuild = stepData.prodBuild?.ciBuild;
    const workflowData = stepData.workflowData;
    const tagData = stepData.tagData;

    const topBar = <CIBuildInfoTopBar ciBuild={ciBuild} workflowData={workflowData} />;

    return (
        <StepRunSummaryContainer topBar={topBar}>
            {!shouldDisplayCompactVersion && (
                <>
                    <StepRunSummaryDetailItem
                        header="BRANCH"
                        body={<CIBuildInfoBranchItem ciBuild={ciBuild} workflowData={workflowData} />}
                    />
                    <StepRunSummaryDetailSeparator />
                    <StepRunSummaryDetailItem
                        header="COMMIT"
                        body={<CIBuildInfoCommitItem ciBuild={ciBuild} workflowData={workflowData} />}
                    />
                    <StepRunSummaryDetailSeparator />
                    <StepRunSummaryDetailItem
                        header="MESSAGE"
                        body={<CIBuildInfoMessageItem ciBuild={ciBuild} workflowData={workflowData} />}
                    />
                    {tagData && <TagDetailSection tagData={tagData} />}
                </>
            )}
        </StepRunSummaryContainer>
    );
};
